import { AxiosResponse } from 'axios';

import { HttpClient } from 'api/HttpClient';

export interface CheckPasswordRequestDto {
  userName: string;
  password: string;
}

export interface CheckPasswordResponseDto {
  hasAccess: boolean;
}

export default class PasswordProtectionApi extends HttpClient {
  public constructor() {
    super(process.env.REACT_APP_API_URL + '/password-protection' || '');
  }

  public async check(checkPasswordRequestDto: CheckPasswordRequestDto) {
    return this.instance
      .post('/check', checkPasswordRequestDto)
      .then((response: AxiosResponse<CheckPasswordResponseDto>) => response.data);
  }
}

export const passwordProtectionApi = new PasswordProtectionApi();
